"use client";

import { useAttributionCapture } from "./useAttributionCapture";

/** Renders nothing — just runs the attribution-capture effect at the root. */
export function AttributionCapture() {
  useAttributionCapture();
  return null;
}
